import { Box } from "@mui/material";
import type { Dayjs } from "dayjs";
import { forwardRef, type RefObject } from "react";
import type { DateFilterType } from "@/utils/interfaces";
import { ViewHeader } from "@/components/schedule/components/ViewHeader";
import { ClinicalPractitionerSelect } from "./ClinicalPractitionerSelect";
import type { ClinicalPractitionerEntry } from "src-next/modules/clinical-insights/types/analysisTypes";

interface ClinicalInsightsFilterBarProps {
  selectedDate: Dayjs;
  dateFilterType: string;
  onDateChange: (date: Dayjs) => void;
  onFilterTypeChange: (type: DateFilterType) => void;
  onResetAll: () => void;
  hasActiveFilters: boolean;
  practitionerId: string;
  onPractitionerChange: (value: string) => void;
  practitioner?: ClinicalPractitionerEntry[];
  showPractitionerSelect?: boolean;
  periodDateAnchorRef?: RefObject<HTMLDivElement | null>;
}

export const ClinicalInsightsFilterBar = forwardRef<
  HTMLDivElement,
  ClinicalInsightsFilterBarProps
>(function ClinicalInsightsFilterBar(
  {
    selectedDate,
    dateFilterType,
    onDateChange,
    onFilterTypeChange,
    onResetAll,
    hasActiveFilters,
    practitionerId,
    onPractitionerChange,
    practitioner,
    showPractitionerSelect = true,
    periodDateAnchorRef,
  },
  ref
) {
  const filterType: DateFilterType =
    dateFilterType === "year" ? "month" : (dateFilterType as DateFilterType);

  return (
    <Box ref={ref}>
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          alignItems: { md: "center" },
          gap: 2,
        }}
      >
        <Box ref={periodDateAnchorRef} sx={{ flex: 1, minWidth: 0 }}>
          <ViewHeader
            dateFilter={selectedDate}
            filterType={filterType}
            setDateFilter={onDateChange}
            setFilterType={onFilterTypeChange}
            showAdminFilters={false}
            filtersAlign="center"
            onReset={hasActiveFilters ? onResetAll : undefined}
            resetButtonProps={{ tooltip: "Voltar ao mês atual" }}
          />
        </Box>
        {showPractitionerSelect ? (
          <ClinicalPractitionerSelect
            practitionerId={practitionerId}
            onPractitionerChange={onPractitionerChange}
            practitioner={practitioner}
          />
        ) : null}
      </Box>
    </Box>
  );
});
